import { render } from "./OfficerCredits.vue?vue&type=template&id=6bdff6f3"
import script from "./OfficerCredits.vue?vue&type=script&lang=js"
export * from "./OfficerCredits.vue?vue&type=script&lang=js"

import "./OfficerCredits.vue?vue&type=style&index=0&id=6bdff6f3&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__